import type {
  GetConversationRequest,
  GetConversationResponse,
  ListConversationsResponse,
  SaveConversationRequest,
  SaveConversationResponse,
} from "@/api/ai-chat";
import type { ConversationKind, Scope } from "@/ai-chat/sseClient";

import { PREVIEW_ENV_ID } from "../runtime";
import {
  PREVIEW_UID,
  getConversation,
  listConversations,
  upsertConversation,
} from "../ai-chat/store";

export function handleListAiChatConversations(
  _params: Record<string, never>,
): ListConversationsResponse {
  return listConversations();
}

export function handleGetAiChatConversation(
  params: GetConversationRequest,
): GetConversationResponse {
  const result = getConversation(params.conversation_id);
  if (result) return result;
  // The real backend returns 404 here; the frontend treats that as "navigate
  // back to /ai-chat". For preview mode we return an empty conversation
  // shell so the page doesn't trip an error path on a brand-new id.
  const now = new Date().toISOString();
  return {
    conversation: {
      id: params.conversation_id,
      env_id: PREVIEW_ENV_ID,
      uid: PREVIEW_UID,
      title: "",
      kind: "standard",
      status: "active",
      processing_status: "idle",
      processing_started_at: null,
      last_message_at: null,
      created_at: now,
      updated_at: now,
    },
    messages: [],
  };
}

// SaveConversationRequest is defined in api/ai-chat.ts without a `kind`
// field, but the actual call from useCreateAndNavigateToConversation includes
// it when present. We accept the broader shape here so we can persist the
// kind into the local store.
type SaveConversationRequestWithKind = SaveConversationRequest & {
  kind?: ConversationKind;
  scope?: Scope;
};

export function handleSaveAiChatConversation(
  params: SaveConversationRequestWithKind,
): SaveConversationResponse {
  upsertConversation({
    id: params.id,
    title: params.title,
    status: params.status,
    kind: params.kind,
    scope: params.scope,
  });
  return {};
}
